module.exports = __webpack_public_path__ + "img/bg5.ef6f7ab.png";